
export default {
  namespaced: true,
  state: {
    experiments: [],
  },

  getters: {
    experiments: state => state.experiments,
  },

  mutations: {
    SET_USER_EXPERIMENTS: (state, payload) => {
      state.experiments =  payload
    },
  },

  actions: {
    async setUserExperiments ({ commit }, payload) {
      try {
      const response = await this._vm.api.post('/experiments', {
        experiments: payload
      })
      if (response?.status === 200 && response?.data.length > 0) {
        commit('SET_USER_EXPERIMENTS', response.data)
      }
      } catch (e) {
        console.warn(e.message)
      }
    },

    async setVisited({ commit, state }, payload) {
      try {
        const response = await this._vm.api.post('/experiments/visit', {
          experiment: payload
        })

        if (response?.status === 200 && response.data?.name) {
            const responseData = state.experiments.filter(el => el.name === response.data.name)

            commit('SET_USER_EXPERIMENTS', responseData)
        }
      } catch (e) {
        console.warn(e.message)
      }
    },

    async setExperiments ({ commit }, payload) {
      commit('SET_USER_EXPERIMENTS', payload)
    }
  }

}